module.exports = __webpack_public_path__ + "img/notice.7655c7d2.jpg";